export const ONE_DAY_MS = 60 * 60 * 24 * 1000;
export const ONE_HOUR_MS = 60 * 60 * 1000;
export const ONE_MINUTE_MS = 60 * 1000;
export const FOUR_HALF_HOURS_MS = 4.5 * 60 * 60 * 1000;
